import ApiService from "@/common/api.service";

const PATH = "stock/transport-orders";

export const GET_STOCK_TRANSPORT_ORDER_STATUSES = "getStockTransportOrderStatuses";
export const GET_STOCK_TRANSPORT_DIRECTIONS = "getStockTransportDirections";
export const GET_STOCK_TRANSPORT_MODES = "getStockTransportModes";
export const GET_STOCK_TRANSPORT_ORDERS = "getStockTransportOrders";
export const GET_STOCK_TRANSPORT_ORDER = "getStockTransportOrder";
export const CREATE_STOCK_TRANSPORT_ORDER = "createStockTransportOrder";
export const UPDATE_STOCK_TRANSPORT_ORDER = "updateStockTransportOrder";
export const CANCEL_STOCK_TRANSPORT_ORDER = "cancelStockTransportOrder";
export const DISCARD_STOCK_TRANSPORT_ORDER = "discardStockTransportOrder";
export const GET_STOCK_TRANSPORT_ORDER_DRAFT_FROM_PO = "getStockTransportOrderDraftFromPurchaseOrder";
export const GET_STOCK_TRANSPORT_ORDER_DRAFT_FROM_SO = "getStockTransportOrderDraftFromSalesOrder";
export const SEND_STOCK_TRANSPORT_ORDER = "sendStockTransportOrder";
export const CONFIRM_STOCK_TRANSPORT_ORDER = "confirmStockTransportOrder";
export const MARK_STOCK_TRANSPORT_IN_TRANSIT = "markStockTransportInTransit";
export const MARK_STOCK_TRANSPORT_DELIVERED = "markStockTransportDelivered";
export const REGENERATE_STOCK_TO_DOCUMENT = "regenerateStockTransportOrderDocument";
export const UPLOAD_STOCK_TO_FILES = "uploadStockTransportOrderFiles";
export const DELETE_STOCK_TO_FILE = "deleteStockTransportOrderFile";
export const DOWNLOAD_STOCK_TO_FILE = "downloadStockTransportOrderFile";
export const CREATE_RECEIPT_FROM_TO = "createReceiptFromTransportOrder";
export const CREATE_DELIVERY_FROM_TO = "createDeliveryFromTransportOrder";
export const GET_STOCK_TRANSPORT_ORDER_SUGGEST_LOTS = "getStockTransportOrderSuggestLots";
export const GET_STOCK_TRANSPORT_ORDER_IMPORTABLE_VIRTUAL_RECEIPTS =
  "getStockTransportOrderImportableVirtualReceipts";
export const IMPORT_VIRTUAL_RECEIPT_INTO_TRANSPORT_ORDER =
  "importVirtualReceiptIntoTransportOrder";

const actions = {
  [GET_STOCK_TRANSPORT_ORDER_STATUSES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("stock/transport-order-statuses")
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSPORT_DIRECTIONS]() {
    return new Promise((resolve, reject) => {
      ApiService.get("stock/transport-directions")
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSPORT_MODES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("stock/transport-modes")
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSPORT_ORDERS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSPORT_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_TRANSPORT_ORDER](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_TRANSPORT_ORDER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CANCEL_STOCK_TRANSPORT_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/cancel`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DISCARD_STOCK_TRANSPORT_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/discard`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSPORT_ORDER_DRAFT_FROM_PO](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("stock/purchase-orders", `${id}/transport-order-draft`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSPORT_ORDER_DRAFT_FROM_SO](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("stock/sales-orders", `${id}/transport-order-draft`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [SEND_STOCK_TRANSPORT_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/send`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CONFIRM_STOCK_TRANSPORT_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/confirm`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [MARK_STOCK_TRANSPORT_IN_TRANSIT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/mark-in-transit`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [MARK_STOCK_TRANSPORT_DELIVERED](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/mark-delivered`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [REGENERATE_STOCK_TO_DOCUMENT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/regenerate-document`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPLOAD_STOCK_TO_FILES](context, payload) {
    const formData = new FormData();
    (payload.files || []).forEach((file) => formData.append("files[]", file));

    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/files`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_TO_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${payload.id}/files/${payload.fileId}`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DOWNLOAD_STOCK_TO_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${PATH}/${payload.id}/files/${payload.fileId}/download`,
        payload.originalName || payload.name || "download"
      )
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },

  [CREATE_RECEIPT_FROM_TO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/create-receipt`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_DELIVERY_FROM_TO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/create-delivery`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSPORT_ORDER_SUGGEST_LOTS](context, payload) {
    const transportOrderId = typeof payload === "object" ? payload.transportOrderId : payload;
    const params = typeof payload === "object" ? payload.params || {} : {};

    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/${transportOrderId}/suggest-lots`, params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSPORT_ORDER_IMPORTABLE_VIRTUAL_RECEIPTS](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${PATH}/${id}/importable-virtual-receipts`)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [IMPORT_VIRTUAL_RECEIPT_INTO_TRANSPORT_ORDER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/import-virtual-receipt`, {
        receipt_id: payload.receipt_id,
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
};
